export const detailMessage = detail => {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(detailMessage).filter(Boolean).join(' ');
  if (detail && typeof detail === 'object') {
    const location = Array.isArray(detail.loc) ? detail.loc.filter(part => part !== 'body').join('.') : '';
    return detail.msg ? `${location ? `${location}: ` : ''}${detail.msg}` : JSON.stringify(detail);
  }
  return 'Nie udało się przetworzyć pliku.';
};

export const errorMessage = async error => {
  const data = error.response?.data;
  if (data instanceof Blob) {
    try { return detailMessage(JSON.parse(await data.text()).detail); } catch (_) { return 'Nie udało się przetworzyć pliku.'; }
  }
  return detailMessage(data?.detail);
};
